import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

function DeleteSalesRep() {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    branch: '',
  });

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  // Fetch the sales rep data by ID when the component mounts
  useEffect(() => {
    const getSalesRepData = async () => {
      const apiUrl = `https://xd8p7gx9ld.execute-api.ap-southeast-1.amazonaws.com/prod/getSalesRep/${id}`;

      try {
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`Error fetching sales rep data: ${response.statusText}`);
        }

        const salesRepData = await response.json();
        setFormData({
          firstname: salesRepData.firstname || '',
          lastname: salesRepData.lastname || '',
          branch: salesRepData.branch || '',
        });
        setIsLoading(false);
      } catch (error) {
        setError(error.message);
        setIsLoading(false);
      }
    };

    if (id) {
      getSalesRepData();
    } else {
      setError('Sales Rep ID not found in the URL');
      setIsLoading(false);
    }
  }, [id]);

  const handleDelete = async () => {
    setIsLoading(true);

    // Make DELETE request to your API Gateway to delete the sales rep
    try {
      const response = await fetch(`https://vgtqbgcqw9.execute-api.ap-southeast-1.amazonaws.com/prod/deleteSalesRep/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        setSuccessMessage('Sales representative deleted successfully!');
        setTimeout(() => navigate('/list-salesreps'), 2000); // Redirect after 2 seconds
      } else {
        const result = await response.json();
        console.error('Error deleting sales rep:', result);
        setError('Error deleting sales representative');
      }
    } catch (error) {
      console.error('Error:', error);
      setError('An error occurred while deleting the sales representative');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <div>Loading sales representative details...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <h1 className="page-header">Delete Sales Representative</h1>

      {successMessage && (
        <div className="success-message">
          {successMessage}
          <button className="close-btn" onClick={() => setSuccessMessage('')}>
            <span className="material-icons">close</span>
          </button>
        </div>
      )}

      <form className="salesrep-form">
        {/* First Name */}
        <div className="form-group">
          <label htmlFor="firstname">First Name</label>
          <input
            type="text"
            id="firstname"
            name="firstname"
            value={formData.firstname}
            disabled
          />
        </div>

        {/* Last Name */}
        <div className="form-group">
          <label htmlFor="lastname">Last Name</label>
          <input
            type="text"
            id="lastname"
            name="lastname"
            value={formData.lastname}
            disabled
          />
        </div>

        {/* Branch */}
        <div className="form-group">
          <label htmlFor="branch">Branch</label>
          <input
            type="text"
            id="branch"
            name="branch"
            value={formData.branch}
            disabled
          />
        </div>

        {/* Form buttons */}
        <div className="form-buttons">
          <button type="button" className="btn submit-btn" onClick={handleDelete} disabled={isLoading}>
            {isLoading ? 'Deleting...' : 'Delete'}
          </button>
          <button type="button" className="btn cancel-btn" onClick={() => navigate('/manage-salesreps')}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default DeleteSalesRep;
